








import { Component, Vue } from 'vue-property-decorator';
import particlesjs_config from '@/data/particlesjs-config.json'
require('particles.js')

@Component({
  components: {
  },
})
export default class Home extends Vue {
  mounted() {
    // @ts-ignore
    window.particlesJS("particles-js", particlesjs_config)
  }

  created() {
    // finsish typing
    setTimeout(() => {
      console.log('setTimeout')
      if(this.$refs.typewriter) {
        // @ts-ignore
        this.$refs.typewriter.style.width = "38ch"
      }
    }, 8000);
  }
}
